import { Component, OnInit } from '@angular/core';
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import {NgxSpinnerService} from 'ngx-spinner';
import {IOption} from "ng-select";

import {HelperService} from "../../services/helper.service";

@Component({
  selector: 'app-add-major-customer-modal',
  templateUrl: './add-major-customer-modal.component.html',
  styleUrls: ['./add-major-customer-modal.component.scss'],
  providers: [  HelperService]
})
export class AddMajorCustomerModalComponent implements OnInit {

  public major_customer: any = {};
  public countryArr: Array<IOption> = [];

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private helperService: HelperService, 

  ) {}

  ngOnInit() {
  }


  processCountryDropdown(value){
    this.major_customer.country = value
  }

  public closeModal() {
    this.bsModalRef.hide();
    /*   this.modalService.setDismissReason('modalClosed');*/
    this.modalService.setDismissReason("modalClosed");
  }

  public closeModalAfterSave() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("modalSaved");
  }

  public createContact(event) {
    this.closeModalAfterSave()
  }

}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/add-major-customer-modal/add-major-customer-modal.component.ts